var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _vm.viewData.loading
        ? _c("loading-list")
        : _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
                      },
                      [
                        _c("h1", { staticClass: "h2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.viewData.id
                                  ? `Editar ${_vm.state.name}`
                                  : "Novo Usuário"
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-breadcrumb", {
                        attrs: {
                          items: [
                            {
                              text:
                                "Lista de " +
                                this.getProfileName(this.state.profile),
                              href: "/#/" + this.state.profile + "s"
                            },
                            {
                              text: "Cadastro de usuários",
                              href: "#",
                              active: true
                            }
                          ]
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "b-form",
                            [
                              _c("error-container", {
                                attrs: { errors: _vm.viewData.errors || [] }
                              }),
                              _vm._v(" "),
                              _vm.state.profile === "consumer" ||
                              _vm.state.profile === "investor"
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-1",
                                        label: "Indicado por",
                                        "label-for": "input-1"
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          options: _vm.viewData.parents,
                                          label: "label"
                                        },
                                        on: { search: _vm.getParent },
                                        model: {
                                          value: _vm.state.parentId,
                                          callback: function($$v) {
                                            _vm.$set(_vm.state, "parentId", $$v)
                                          },
                                          expression: "state.parentId"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b-form-invalid-feedback", [
                                        _vm._v(
                                          _vm._s(_vm.getError("socialNumber"))
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "CPF/CNPJ",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "###.###.###-##",
                                          "##.###.###/####-##"
                                        ],
                                        expression:
                                          "['###.###.###-##', '##.###.###/####-##']"
                                      }
                                    ],
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o CPF/CNPJ",
                                      state: _vm.isOk("socialNumber")
                                    },
                                    model: {
                                      value: _vm.state.socialNumber,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "socialNumber", $$v)
                                      },
                                      expression: "state.socialNumber"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("socialNumber")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Email",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "email",
                                      required: "",
                                      placeholder: "Informe o email",
                                      state: _vm.isOk("email")
                                    },
                                    model: {
                                      value: _vm.state.email,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "email", $$v)
                                      },
                                      expression: "state.email"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("email")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-2",
                                    label: "Nome",
                                    "label-for": "input-2"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o nome",
                                      state: _vm.isOk("name")
                                    },
                                    model: {
                                      value: _vm.state.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "name", $$v)
                                      },
                                      expression: "state.name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("name")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Telefone",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##) ####-####",
                                          "(##) #####-####"
                                        ],
                                        expression:
                                          "['(##) ####-####', '(##) #####-####']"
                                      }
                                    ],
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o Telefone",
                                      state: _vm.isOk("phone")
                                    },
                                    model: {
                                      value: _vm.state.phone,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "phone", $$v)
                                      },
                                      expression: "state.phone"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("phone")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Data de Nascimento",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-datepicker", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      state: _vm.isOk("birthDate"),
                                      id: "example-datepicker",
                                      placeholder: "Selecione uma data"
                                    },
                                    model: {
                                      value: _vm.state.birthDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "birthDate", $$v)
                                      },
                                      expression: "state.birthDate"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("birthDate")))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("birthDate")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("image-upload", {
                                attrs: {
                                  currentUrl: this.state.photoUrl,
                                  updateUrl: _vm.updateUrl,
                                  setLoading: _vm.setLoadingPhoto
                                }
                              }),
                              _vm._v(" "),
                              !_vm.viewData.loadingPhoto
                                ? _c("submit-button", {
                                    attrs: {
                                      action: () => _vm.save(),
                                      label: "Salvar"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }